module.exports = "<p>\n  my-recipes works!\n</p>\n"